import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Div = styled.div``;

/**
 * @param {AnchorDivProps} props
 * @returns {React.ReactElement} The rendered component
 */
const AnchorDiv = ({ sessionStorageKey, className }) => {
  const divRef = useRef(null);

  const setElmtsOffsetTop = () => {
    sessionStorage.removeItem(sessionStorageKey);
    setTimeout(() => {
      if (divRef.current) {
        const element = divRef.current || {};
        const elementYOffset =
          (divRef.current && element.getBoundingClientRect().top) || 0;
        sessionStorage.setItem(sessionStorageKey, elementYOffset.toString());
      }
    }, 250);
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setElmtsOffsetTop();
    window.addEventListener('resize', setElmtsOffsetTop, false);
    return function cleanup() {
      window.removeEventListener('resize', setElmtsOffsetTop, false);
    };
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return <Div className={className} ref={divRef} />;
};

export default AnchorDiv;
